<template>
  <div class="email-optin-wrap">
    <main class="screen" role="main">

      <span class="badge">Quiz abgeschlossen</span>

      <div class="intro">
        <h1 class="intro-title">Möchtest du in 3 Monaten nochmals teilnehmen?</h1>
        <p class="intro-text">
          Mit einer kurzen Erinnerung per E-Mail kannst du sehen, wie sich dein
          Ergebnis über die Zeit entwickelt.
        </p>
      </div>

      <ul class="benefits">
        <li>
          <span class="benefit-icon" aria-hidden="true">✓</span>
          <span>Eine einzige Erinnerung in 3 Monaten, keine Werbung.</span>
        </li>
        <li>
          <span class="benefit-icon" aria-hidden="true">✓</span>
          <span>Vergleich mit deinem heutigen Ergebnis.</span>
        </li>
        <li>
          <span class="benefit-icon" aria-hidden="true">✓</span>
          <span>Du kannst dich jederzeit abmelden.</span>
        </li>
      </ul>

      <div class="form-row">
        <label for="email">E-Mail-Adresse</label>
        <input
          type="email"
          id="email"
          placeholder="dein.name@beispiel.ch"
          autocomplete="email"
          inputmode="email"
          v-model="email"
        >
      </div>

      <p class="privacy-note">
        Deine Quiz-Antworten bleiben anonym. Die E-Mail-Adresse wird nur für
        die Erinnerung verwendet und nicht mit den Antworten verknüpft.
      </p>

      <div class="footer">
        <button
          type="button"
          class="submit-button"
          :disabled="!isValidEmail"
          @click="submit"
        >Erinnerung aktivieren</button>
        <button
          type="button"
          class="skip-button"
          @click="skip"
        >Nein danke, fertig</button>
      </div>

    </main>
  </div>
</template>

<script>
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'EmailOptIn',
  data() {
    return { email: '' };
  },
  computed: {
    isValidEmail() {
      return EMAIL_RE.test(this.email.trim());
    },
  },
  methods: {
    submit() {
      if (!this.isValidEmail) return;
      this.$router.push('/postsurvey/thanks');
    },
    skip() {
      this.$router.push('/postsurvey/thanks');
    },
  },
};
</script>

<style scoped>
.email-optin-wrap {
  --color-bg-page: #f5f4ef;
  --color-bg-card: #ffffff;
  --color-bg-muted: #f1efe8;
  --color-text-primary: #2c2c2a;
  --color-text-secondary: #5f5e5a;
  --color-text-tertiary: #888780;
  --color-border: rgba(0, 0, 0, 0.15);
  --color-accent: #534AB7;
  --color-accent-light: #EEEDFE;
  --radius-md: 8px;
  --radius-lg: 12px;
  --font-sans: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;

  background: var(--color-bg-page);
  font-family: var(--font-sans);
  color: var(--color-text-primary);
  line-height: 1.5;
  min-height: 100%;
  padding: 1.25rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  box-sizing: border-box;
}

.email-optin-wrap *,
.email-optin-wrap *::before,
.email-optin-wrap *::after {
  box-sizing: border-box;
}

.screen {
  width: 100%;
  max-width: 420px;
  background: var(--color-bg-card);
  border-radius: var(--radius-lg);
  border: 0.5px solid var(--color-border);
  padding: 1.5rem 1.25rem;
  min-height: 600px;
  display: flex;
  flex-direction: column;
}

.badge {
  align-self: flex-start;
  background: var(--color-accent-light);
  color: var(--color-accent);
  font-size: 12px;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: var(--radius-md);
  margin-bottom: 1rem;
  letter-spacing: 0.02em;
}

.intro {
  margin-bottom: 1.5rem;
}

.intro-title {
  font-size: 24px;
  font-weight: 500;
  margin: 0 0 12px;
  line-height: 1.25;
}

.intro-text {
  font-size: 15px;
  color: var(--color-text-secondary);
  margin: 0;
  line-height: 1.6;
}

.benefits {
  background: var(--color-bg-muted);
  border-radius: var(--radius-md);
  padding: 14px 16px;
  margin: 0 0 1.5rem;
  list-style: none;
}

.benefits li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  font-size: 14px;
  color: var(--color-text-secondary);
  line-height: 1.5;
  padding: 4px 0;
}

.benefit-icon {
  flex-shrink: 0;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--color-accent);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 500;
  margin-top: 2px;
}

.form-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 1rem;
}

.form-row label {
  font-size: 13px;
  color: var(--color-text-secondary);
  font-weight: 500;
}

.form-row input[type="email"] {
  padding: 14px 16px;
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 16px;
  font-family: inherit;
  background: var(--color-bg-card);
  color: var(--color-text-primary);
}

.form-row input[type="email"]:focus {
  outline: none;
  border-color: var(--color-accent);
  box-shadow: 0 0 0 2px var(--color-accent-light);
}

.privacy-note {
  font-size: 12px;
  color: var(--color-text-tertiary);
  margin: 0 0 1.25rem;
  line-height: 1.5;
}

.footer {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.submit-button {
  width: 100%;
  padding: 14px;
  background: var(--color-bg-muted);
  color: var(--color-text-tertiary);
  border: 0.5px solid var(--color-border);
  border-radius: var(--radius-md);
  font-size: 15px;
  font-family: inherit;
  cursor: not-allowed;
}

.submit-button:not(:disabled) {
  background: var(--color-accent);
  color: white;
  border-color: var(--color-accent);
  cursor: pointer;
}

.submit-button:not(:disabled):hover {
  opacity: 0.9;
}

.skip-button {
  width: 100%;
  padding: 14px;
  background: transparent;
  color: var(--color-text-secondary);
  border: none;
  font-size: 14px;
  font-family: inherit;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 3px;
}

.skip-button:hover {
  color: var(--color-text-primary);
}
</style>
